import { AfterContentChecked, Component, EventEmitter, Input, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { Finding, AuditStatus } from '../../audit.model';
import { TableData, TableOptions, RequestResult } from '../../../shared/shared.model';
import { DatePipe } from '@angular/common';
import { DISPLAY_DATE_FORMAT } from '../../../app.constants';
import { FindingService } from '../../finding.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'iaud-finding-list',
  templateUrl: './finding-list.component.html',
  styleUrls: ['./finding-list.component.scss']
})
export class FindingListComponent implements OnInit, AfterContentChecked {
  @ViewChild('capaCellTemplate') findingsCellTemplate: TemplateRef<any>;
  @ViewChild('statusCellTemplate') statusCellTemplate: TemplateRef<any>;
  @ViewChild('ownersDetailTemplate') ownersCellTemplate: TemplateRef<any>;

  @Input()
  auditId: number = 0;
  @Input()
  reloadFinding?: EventEmitter<boolean>;
  @Input()
  auditStatus: string;

  auditStatusEnum = AuditStatus;

  findingTableData: TableData<Finding>;
  forceReloadEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  hasInitialFindings: boolean = null;

  findingTableOptions: TableOptions = {
    actionButtons: true,
    columns: [
      {
        title: 'Finding ID',
        fieldName: 'findingId',
      },
      {
        title: 'Finding Title',
        fieldName: 'findingTitle',
      },
      {
        title: 'CAPA/ECs',
        fieldName: 'findingCapaCount',
      },
      {
        title: 'Finding Status',
        fieldName: 'status',
      },
      {
        title: 'CAPA/EC Activity Status',
        fieldName: 'capaStatus',
      },
      {
        title: 'Evidence Approval Due Date',
        fieldName: 'dueDate',
        pipe: new DatePipe('en-US'),
        pipeParams: DISPLAY_DATE_FORMAT,
      },
    ],
    additionalInfo: [
      {
        title: 'Finding Code',
        fieldName: 'findingCode',
      },
      {
        title: 'Deviation Owners',
        fieldName: 'findingOwner',
      },
      {
        title: 'Description',
        fieldName: 'findingDescription',
      },
    ]
  };

  constructor(
    private findingService: FindingService
  ) { }

  ngOnInit(): void {
    this.findingTableOptions.hrefBase = `/audit/${this.auditId}/finding`;
    this.reloadFindingList()
    .subscribe((table: TableData<Finding>) => {
      this.findingTableData = table;
      if (this.hasInitialFindings == null) {
        this.hasInitialFindings = table.items.length > 0;
      }
    });
    if (this.reloadFinding) {
      this.reloadFinding.subscribe(() => {
          this.forceReloadEvent.emit(true);
        });
    }
  }
  ngAfterContentChecked(): void {
    this.findingTableOptions.columns[2].customTemplate = this.findingsCellTemplate;
    this.findingTableOptions.columns[4].customTemplate = this.statusCellTemplate;
    this.findingTableOptions.additionalInfo[1].customTemplate = this.ownersCellTemplate;
  }
  deleteData(id: number): Observable<RequestResult> {
    return this.findingService.deleteFinding(id);
  }

  reloadFindingList(): Observable<TableData<Finding>> {
    return this.findingService.getFindingList(this.auditId);
  }
}
